import React from 'react';
import {Button} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {useOffer} from "../../OfferContext";
import styles from "./OfferBanner.module.scss";
import classNames from "classnames";
import {LayoutTopAlertProps} from "../../../../common/components/Layout/LayoutTopAlert/types";
import Container from "react-bootstrap/Container";
import offerWarning from "../../../../assets/images/offer-warning.svg";
import {useIsMobile} from "../../../../common/utils/useIsMobile";

/**
 * Баннер с предупреждением о необходимости принять оферту
 */
const OfferBanner: React.VFC<LayoutTopAlertProps> = ({
  className,
}) => {
  const {t} = useTranslation();
  const {needAcceptOffer, offerDismissed, openOfferModal, openOfferScreen} = useOffer();
  const isMobile = useIsMobile();

  // Показывать баннер только если нужно принять оферту и пользователь отложил принятие
  if (!needAcceptOffer || !offerDismissed) {
    return null;
  }

  const content = (
    <Container className={classNames(styles.content)}>
      <div className={styles.info}>
        <div className={styles.icon}>
            <img
                src={offerWarning}
                alt=""
            />
        </div>
          <div className={styles.textContent}>
              <p className={styles.title}>{t('offer.bannerTitle')}</p>
              <p className={styles.description}>{t('offer.bannerText')}</p>
        </div>
      </div>

      <Button
        className={styles.button}
        variant="outline-primary"
        onClick={() => isMobile ? openOfferScreen(false) : openOfferModal(false)}
      >
        {t('offer.bannerButton')}
      </Button>
    </Container>
  );

  return (
    <>
      <div className={styles.banner}>
        {content}
      </div>

      <div className={classNames(
        styles.banner,
        styles['banner--offset'],
      )}>
        {content}
      </div>
    </>
  );
};

export default OfferBanner;
